export default {
  "recent_activity":"最近活动",
  "you_have_unfinished_invoice":"你有一份未完成的发票",
  "you_have_unfinished_estimate":"你有一份未完成的报价单",
  "invoice":"发票",
  "estimate":"报价单",
  "home":"首页",
  "document":"文件",
  "client":"客户",
  "report":"报告",
  "new":"新建",
  "no_client_found":"未找到客户。",
  "search":"搜索",
  "clients":"客户",
  "documents":"文件",
  "no_document_found":"未找到文件。",
  "cancel":"取消",
  "new_client":"新客户",
  "add_client":"添加客户",
  "client_name_is_required":"客户名称是必填项！",
  "client_name":"客户名称",
  "email":"邮箱",
  "phone":"电话",
  "mobile":"手机",
  "fax":"传真",
  "address":"地址",
  "address_1":"地址 1",
  "address_2":"地址 2",
  "city":"城市",
  "state_province":"州/省",
  "zip_postal_code":"邮政编码",
  "country":"国家",
  "filter_documents":"筛选文件",
  "apply_filter":"应用筛选",
  "document_type":"文件类型",
  "all":"全部",
  "send_state":"发送状态",
  "sent":"已发送",
  "not_sent":"未发送",
  "payment_state":"支付状态",
  "paid":"已支付",
  "not_paid":"未支付",
  "overdue":"逾期",
  "date":"日期",
  "this_month":"本月",
  "this_year":"今年",
  "custom":"自定义",
  "from":"从",
  "to":"到",
  "preview":"预览",
  "summary":"摘要",
  "estimate_number":"报价单编号",
  "issued":"签发日期",
  "valid_until":"有效期至",
  "history":"历史",
  "show":"显示",
  "share":"分享",
  "print":"打印",
  "download_pdf":"下载 PDF",
  "send_estimate":"发送报价单",
  "document_history":"文件历史",
  "mark_as_paid":"标记为已支付",
  "paid":"已支付",
  "invoice_number":"发票编号",
  "due":"到期",
  "send_invoice":"发送发票",
  "new_item":"新项目",
  "name":"名称",
  "price":"价格",
  "item_name":"项目名称",
  "item_price":"项目价格",
  "item_name_is_required":"项目名称是必填项！",
  "item_price_is_required":"项目价格是必填项！",
  "item_tax_state":"项目税务状态",
  "add_item":"添加项目",
  "new_service":"新服务",
  "unit":"单位 (小时, 天)",
  "service_name_is_required":"服务名称是必填项！",
  "service_price_is_required":"服务价格是必填项！",
  "tax":"税",
  "service_tax_state":"服务税务状态",
  "add_service":"添加服务",
  "items_and_services":"项目和服务",
  "items":"项目",
  "item":"项目",
  "services":"服务",
  "update_item":"更新项目",
  "are_you_sure":"你确定吗？",
  "this_action_will_delete_the_item":"此操作将删除该项目。",
  "delete":"删除",
  "update":"更新",
  "update_service":"更新服务",
  "this_action_will_delete_the_service":"此操作将删除该服务。",
  "business":"公司",
  "business_details":"公司详情",
  "business_details_1":"公司详情",
  "business_logo":"公司标志",
  "business_name":"公司名称",
  "business_name_is_required":"公司名称是必填项！",
  "mobile_number":"手机号码",
  "mobile_number_2":"备用手机号码",
  "website":"网站",
  "street":"街道",
  "street_2":"街道 2",
  "save":"保存",
  "settings":"设置",
  "business_settings":"公司设置",
  "payment_options":"支付选项",
  "tax_settings":"税务设置",
  "document_settings":"文件设置",
  "template_design_and_settings":"模板设计和设置",
  "app_settings":"应用设置",
  "language":"语言",
  "theme":"主题",
  "dark":"深色",
  "light":"浅色",
  "auto":"自动",
  "subscription":"订阅",
  "rate_us":"评价我们",
  "paypal_email_is_required":"PayPal 邮箱是必填项",
  "online_payments":"在线支付",
  "paypal":"PayPal",
  "paypal_email":"PayPal 邮箱",
  "stripe":"Stripe",
  "payment_instructions":"付款说明",
  "add_instructions":"添加说明以接收付款：\n- 银行账户信息。\n- Venmo、Zelle、Cash App。\n- 其他信息。",
  "apply_tax_to_documents":"将税应用于文件",
  "tax_label":"税务标签",
  "option_1":"选项 1 (%)",
  "option_2":"选项 2 (%)",
  "option_3":"选项 3 (%)",
  "itemsandservices":"项目和服务",
  "preview_and_customize":"预览和自定义",
  "new_estimate":"新建报价单",
  "add_itemandservice":"添加项目/服务",
  "sub-total":"小计",
  "discount":"折扣",
  "total":"总计",
  "estimate_notes":"报价单备注",
  "create_estimate":"创建报价单",
  "new_invoice":"新建发票",
  "invoice_notes":"发票备注",
  "create_invoice":"创建发票",
  "client_details":"客户详情",
  "save_changes":"保存更改",
  "remove_this_client_from_the_document":"从文件中移除此客户！",
  "contact":"联系方式",
  "update_invoice":"更新发票",
  "item_details":"项目详情",
  "remove_this_item_from_the_document":"从文件中移除此项目！",
  "quantity":"数量",
  "item_quantity_is_required!":"项目数量是必填项！",
  "total_price":"总价",
  "service_details":"服务详情",
  "remove_this_service_from_the_document":"从文件中移除此服务！",
  "unit_type":"单位类型",
  "service_quantity_is_required":"服务数量是必填项",
  "select_terms":"选择条款",
  "taxable":"应税",
  "non_taxable":"免税",
  "total_estimates":"总报价单",
  "total_invoices":"总发票",
  "service_name":"服务名称",
  "service_price":"服务价格",
  "no_item_found":"未找到项目。",
  "no_service_found":"未找到服务。",
  "select_your_language":"选择语言",
  "stripe_invoice_link":"Stripe 发票链接",
  "update_estimate":"更新报价单",
  "sub_total":"小计",
  "select_a_currency":"选择货币",
  "reports":"报告",
  "customize":"自定义",
  "edit":"编辑",
  "invoices":"发票",
  "estimates":"报价单",
  "get_statement":"获取对账单",
  "no_client_found_with_the_given_id":"未找到指定 ID 的客户。",
  "no_statement_found":"未找到对账单",
  "no_document_found_for_this_client":"该客户未找到文件。",
  "client_statment":"客户对账单",
  "send_statment":"发送对账单",
  "update_client":"更新客户",
  "remove_this_item":"移除此项目",
  "remove_this_service":"移除此服务",
  "set_as_default":"设为默认",
  "top_invoiced_clients":"最高开票客户",
  "amount":"金额",
  "invoices_up":"发票",
  "quarter":"季度",
  "unpaid":"未支付",
  "top_invoiced_items":"最高开票项目",
  "quantity_up":"数量",
  "top_invoiced_services":"最高开票服务",
  "last_year":"去年",
  "life_time":"全部",
  "ok":"确定",
  "invoice_send_template_subject":"来自 {business_name} 的发票 #{document_number}",
  "invoice_send_template_email":"你好 {client_name},\n\n希望你一切顺利。\n\n我们已开具一份新的发票 (#{document_number})，来自 {business_name}。\n\n你可以通过以下安全链接查看或下载：\n\n🔗 https://snapbill.app/document/{document_id}\n\n如果你对这份发票有任何问题或需要帮助，请随时通过 {business_email} 联系我们。\n\n感谢你对 {business_name} 的信任。\n\n非常感谢你的业务！\n\n此致,\n\n{business_name} 团队",
  "estimate_send_template_subject":"来自 {business_name} 的报价单 #{document_number}",
  "estimate_send_template_email":"你好 {client_name},\n\n希望你一切顺利。\n\n我们已准备好报价单 (#{document_number})，来自 {business_name}，供你审核。\n\n你可以通过以下安全链接查看或下载：\n\n🔗 https://snapbill.app/document/{document_id}\n\n如有任何问题、需要调整或希望继续，请回复此邮件或通过 {business_email} 联系我们。\n\n感谢你考虑 {business_name}。\n\n期待与您合作！\n\n此致,\n\n{business_name} 团队",
  "statement_send_template_subject":"来自 {business_name} 的对账单",
  "statement_send_template_email":"你好 {client_name},\n\n希望你一切顺利。\n\n你最新的对账单来自 {business_name}，现已可用。\n此对账单提供了你的发票和报价单摘要，供你查看。\n\n你可以通过以下安全链接查看或下载：\n\n🔗 https://snapbill.app/statement/{statment_number}\n\n如果你对这份对账单有任何疑问或需要进一步详细信息，请随时通过 {business_email} 联系我们。\n\n感谢你对 {business_name} 的信任。\n\n此致,\n\n{business_name} 团队",
  "no_internet_connection":"无网络连接",
  "you_need_an_internet_connection_to_send_or_share_your_invoice":"你需要网络连接才能发送或分享发票。\n请检查你的连接并稍后再试，或选择离线选项（打印或下载 PDF）继续。",
  "you_need_an_internet_connection_to_send_or_share_your_estimate":"你需要网络连接才能发送或分享报价单。\n请检查你的连接并稍后再试，或选择离线选项（打印或下载 PDF）继续。",
  "you_need_an_internet_connection_to_send_or_share_your_statment":"你需要网络连接才能发送或分享对账单。\n请检查你的连接并稍后再试，或选择离线选项（打印或下载 PDF）继续。",
  "error":"错误",
  "mail_composer_is_not_available_on_this_device":"此设备上不可用邮件编辑器",
  "estimate_full_capital":"报价单",
  "invoice_full_capital":"发票",
  "estimate_to":"报价单收件人",
  "invoice_to":"发票收件人",
  "invoice_no":"发票号：",
  "issue_date":"签发日期：",
  "due_date":"到期日期：",
  "valid_until":"有效期至：",
  "description":"描述",
  "unit_price":"单价",
  "note":"备注：",
  "number_1":"号码 1",
  "number_2":"号码 2",
  "bill_to":"账单至",
  "from_full_capital":"来自",
  "details_full_capital":"详情",
  "valid": "有效",
    "select_contact": "选择联系人",
    "no_contacts": "未找到联系人",
    "import_from_contacts": "从联系人导入",
    "call": "拨打电话",
    "message": "消息",
    "success": "成功",
    "pdf_saved": "PDF 已保存！请前往“文件” → “在我的 iPhone 上” → SnapBill 查看",
    "not_send": "未发送",
    "created": "已创建",
    "send_to": "发送至",
    "signatures": "签名",
    "signature": "签名",
    "new_signature": "新签名",
    "signature_name_is_required": "签名名称为必填项",
    "clear": "清除",
    "delete_signature": "删除签名",
    "this_action_will_delete_the_signature": "此操作将删除签名。",
    "no_signatures_found": "未找到签名",
    "add_your_signature": "添加您的签名",
    "this_action_will_remove_the_signature_from_this_document": "此操作将从此文档中移除签名。",
    "on_receipt": "收到时",
    "three_days": "3 天",
    "ten_days": "10 天",
    "thirty_days": "30 天",
    "no_duo_date": "无到期日期",
    "no_valid_date": "无有效日期",
    "select_date": "选择日期",
    "percentage": "百分比",
    "fix": "固定",
    "please_add_client_detail_to_the_invoice": "请在发票中添加客户信息",
    "please_add_at_least_one_item_to_the_invoice": "请在发票中至少添加一项内容",
    "please_add_client_detail_to_the_estimate": "请在报价中添加客户信息",
    "please_add_at_least_one_item_to_the_estimate": "请在报价中至少添加一项内容",
    "next": "下一步",
    "get_started": "开始使用",
    "create_invoices_and_estimates_in_seconds": "数秒内创建发票和报价",
    "auto_fill_client_details": "自动填写客户信息、应用模板，并在 20 秒内发送。",
    "get_paid_faster_and_know_it_instantly": "更快收款，并即时获知",
    "snapbill_notifies_you_the_moment": "SnapBill 会在客户打开发票或开始付款时立即通知你。不再猜测，实时更新让现金流更快捷。",
    "see_your_business_in_full_color": "全方位了解你的业务",
    "visualize_income_trends": "可视化收入趋势、追踪逾期发票，并识别你的优质客户，通过清晰智能的报告帮助你自信增长。",
    "unlimited_access": "无限访问",
    "not_sure_yet": "还不确定？",
    "enable_free_access": "开启免费访问",
    "best_offer": "最佳优惠",
    "yearly_plan": "年度套餐",
    "per_week": "每周",
    "three_days_free_trail": "3 天免费试用",
    "weekly_plan": "每周套餐",
    "countinue_with_three_days_free": "继续 3 天免费试用",
    "countinue_with_best_offer": "继续最佳优惠",
    "privacy": "隐私",
    "already_subscribed": "已订阅？",
    "terms": "条款",
    "please_select_different_plan": "请选择其他套餐",
    "your_current_plan": "你的当前套餐",
    "statment_of_account": "账户对账单",
    "statment_date": "对账日期",
    "classic": "经典",
    "modern": "现代",
    "wave": "Wave",
    "estimate_no": "报价单编号：",
    "pay_now":"立即支付",
    "copy":"副本",
    "copied":"已复制",
    "invalid_stripe_invoice_link":"无效的 Stripe 发票链接",
    "client_name_viewed_your_invoice_document_number":"{client_name} 已查看您的发票（{document_number}）",
    "client_name_viewed_your_estimate_document_number":"{client_name} 已查看您的报价单（{document_number}）",
    "client_name_started_paying_invoice":"{client_name} 已通过 {payment_method} 开始支付发票（{document_number}）",
    "good_news":"好消息！"
}